/*
   Hannah Vogue theme: global UI behaviours.
   NOTE for Shopify: the header and footer MARKUP now lives in
   sections/header.liquid and sections/footer.liquid (rendered server-side),
   so this file no longer injects any HTML. It only wires up behaviour:
   the mobile menu, the scrolled-header state, and the scroll progress bar.
*/
document.addEventListener('DOMContentLoaded', () => {

    // --- Mobile menu (hamburger & drawer) ---
    const navToggle = document.getElementById('navToggle');
    const navLinks  = document.getElementById('navLinks');
    const navClose  = document.getElementById('navClose');

    if (navToggle && navLinks) {
        const closeMenu = () => {
            navToggle.classList.remove('open');
            navLinks.classList.remove('open');
            navToggle.setAttribute('aria-expanded', 'false');
            navToggle.setAttribute('aria-label', 'Open menu');
            document.body.classList.remove('nav-open');
        };
        const openMenu = () => {
            navToggle.classList.add('open');
            navLinks.classList.add('open');
            navToggle.setAttribute('aria-expanded', 'true');
            navToggle.setAttribute('aria-label', 'Close menu');
            document.body.classList.add('nav-open');
        };

        navToggle.addEventListener('click', () => {
            navLinks.classList.contains('open') ? closeMenu() : openMenu();
        });

        if (navClose) {
            navClose.addEventListener('click', closeMenu);
        }

        // Close on navigation link clicks (unless it's a dropdown toggle)
        navLinks.querySelectorAll('a').forEach(a => {
            a.addEventListener('click', (e) => {
                const parentDropdown = a.closest('.nav-item-has-dropdown');
                if (parentDropdown && a === parentDropdown.firstElementChild && window.innerWidth <= 1024) {
                    // On mobile, first click on dropdown toggle toggles the menu
                    if (!parentDropdown.classList.contains('open-dropdown')) {
                        e.preventDefault();
                        parentDropdown.classList.add('open-dropdown');
                        return;
                    }
                }
                closeMenu();
            });
        });

        document.addEventListener('click', (e) => {
            if (navLinks.classList.contains('open') && !navLinks.contains(e.target) && !navToggle.contains(e.target)) {
                closeMenu();
            }
        });

        document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeMenu(); });
        window.addEventListener('resize', () => { if (window.innerWidth > 1024) closeMenu(); });
    }

    // --- Scrolled header state ---
    const header = document.getElementById('header');
    if (header) {
        const onScroll = () => {
            if (window.scrollY > 60) header.classList.add('scrolled');
            else header.classList.remove('scrolled');
        };
        window.addEventListener('scroll', onScroll);
        onScroll();
    }

    // --- Scroll progress bar ---
    if (!document.querySelector('.hv-progress')) {
        const bar = document.createElement('div');
        bar.className = 'hv-progress';
        document.body.appendChild(bar);
        const onScrollProgress = () => {
            const h = document.documentElement;
            const scrolled = h.scrollTop / (h.scrollHeight - h.clientHeight);
            bar.style.width = (scrolled * 100).toFixed(2) + '%';
        };
        window.addEventListener('scroll', onScrollProgress, { passive: true });
        onScrollProgress();
    }
});
